<template>
  <div style="width: 100%; background-color: var(--grey_alpha)">
    <div class="view-content">
      <document-list
        v-if="isMounted"
        :concordance-word="concordanceWord"
        :execute-on-mount="executeOnMount"
        :publication-year="publicationYear"
      ></document-list>
    </div>
  </div>
</template>

<script>
import DocumentList from "../components/DocumentList";
export default {
  name: "Concordance",
  props: {
    concordanceWord: {
      type: String,
    },
    publicationYear: {
      type: String,
    },
  },
  components: { DocumentList },
  data() {
    return {
      executeOnMount: false,
      isMounted: false,
    };
  },
  mounted() {
    if (typeof this.concordanceWord !== "undefined") {
      this.executeOnMount = true;
    } else {
      this.executeOnMount = false;
      this.isMounted = true;
    }
    this.isMounted = true;
  },
};
</script>

<style scoped>
.box-container {
  border-radius: 0 !important;
}
.container-header {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.method-title {
  display: flex;
  width: 100%;
  font-weight: bold;
}
.box-close-btn {
  width: 25px;
  background-color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Samples.vue